var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var InvitationSuccessIcon = function () { return (_jsx("svg", __assign({ width: '56', height: '56', viewBox: '0 0 56 56', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M28 0C12.544 0 0 12.544 0 28C0 43.456 12.544 56 28 56C43.456 56 56 43.456 56 28C56 12.544 43.456 0 28 0ZM20.412 41.1787L10.36 31.1267C9.268 30.0347 9.268 28.2707 10.36 27.1787C11.452 26.0867 13.216 26.0867 14.308 27.1787L22.4 35.2427L41.664 15.9787C42.756 14.8867 44.52 14.8867 45.612 15.9787C46.704 17.0707 46.704 18.8347 45.612 19.9267L24.36 41.1787C23.296 42.2707 21.504 42.2707 20.412 41.1787Z', fill: '#33B36E' }, void 0) }), void 0)); };
export { InvitationSuccessIcon };
